import React, {memo} from 'react';
import {ModuleTabularPage} from "../../components";
import {AdminModules, AdminReqUrls} from "../../config/AdminConfig";

const NewsPage = memo(() => {
    return (<ModuleTabularPage
        moduleName={AdminModules.News}
        fetchRecordsUrl={AdminReqUrls.admin__news__mainPage_fetch_recordList}
    />)
});
export default NewsPage;
